export const Roles = {
  Anonymous: 'anonymous',
  Authenticated: 'authenticated',
  Admin: 'group_admin',
  Reviewer: 'group_reviewer',
  Reader: 'group_reader'
} as const;

export type RoleKey = keyof typeof Roles;
export type RoleValue = (typeof Roles)[RoleKey];
